import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

// ** Intended for internal use only ** //
@Component({
    selector: "sps-side-nav-branch",
    templateUrl: "./sps-side-nav-branch.component.html"
})
export class SpsSideNavBranchComponent {
    @Input() branch;
    @Input() filter = "";

    constructor(public router: Router) {}

    leafHasChildren(leaf) {
        return leaf.children && leaf.children.length;
    }
}
